import styled from '@emotion/styled';
import { motion } from 'motion/react';

export const Wrapper = styled.div`
  flex: 1;
  padding: 24px;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 20px;
  background: #ffffff;
  overflow: hidden;
  height: 100%;
`;

export const Header = styled.div`
  padding: 24px 24px 12px 16px;
  border-bottom: 1px solid #e9ecef;

  display: flex;
  align-items: center;
  justify-content: space-between;
  align-items: center;
`;

export const TableWrapper = styled(motion.div)`
  flex: 1;
  overflow: auto;

  .ant-table-content {
    overflow: visible !important;

    .ant-table-thead {
      position: sticky;
      top: 0;
      z-index: 1;

      th {
        background: #ffffff;
      }
    }
  }
`;
